/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Rule_Sets_Create_Replace_ValueInputs */

const en_forms_rule_sets_create_replace_value = /** @type {(inputs: Forms_Rule_Sets_Create_Replace_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace Value`)
};

const de_forms_rule_sets_create_replace_value = /** @type {(inputs: Forms_Rule_Sets_Create_Replace_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert ersetzen`)
};

/**
* | output |
* | --- |
* | "Replace Value" |
*
* @param {Forms_Rule_Sets_Create_Replace_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_rule_sets_create_replace_value = /** @type {((inputs?: Forms_Rule_Sets_Create_Replace_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Rule_Sets_Create_Replace_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_rule_sets_create_replace_value(inputs)
	return de_forms_rule_sets_create_replace_value(inputs)
});